import { PaymentsWidgetProps } from '../types/PaymentsWidgetProps';
import { StoreState } from '../types/ReduxMisc';
import { getDeviceType } from '../utils/getDeviceType';

export const getInitialStoreState = (
  props: PaymentsWidgetProps
): Partial<StoreState> => {
  return {
    tpaParams: {
      locale: props.configuration.locale || props.locale || 'en',
      deviceType: props.deviceType || getDeviceType(),
      maxWidth: props.maxWidth,

      configuration: props.configuration,

      externalSubmitButton: props.externalSubmitButton,
      submitButtonText: props.submitButtonText,

      manualPaymentDescription: props.manualPaymentDescription,
      termsAndConditionsLink: props.termsAndConditionsLink,
      useTermsAndConditions: props.useTermsAndConditions,

      isSaveCCEnabled: props.isSaveCCEnabled,
      shouldApplySiteStyles: props.shouldApplySiteStyles,
      siteStyles: props.siteStyles,
      allowRecurringPaymentOnly: props.allowRecurringPaymentOnly,
      allowInPersonPayment: props.allowInPersonPayment,
      allowManualPayment: props.allowManualPayment,
      tokenizeMode: props.tokenizeMode,
    },
  };
};
